import { render, staticRenderFns } from "./FeeRemindBanner.vue?vue&type=template&id=4fd03102&scoped=true&"
import script from "./FeeRemindBanner.vue?vue&type=script&lang=js&"
export * from "./FeeRemindBanner.vue?vue&type=script&lang=js&"
import style0 from "./FeeRemindBanner.vue?vue&type=style&index=0&id=4fd03102&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd03102",
  null
  
)

export default component.exports